import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import PropTypes from 'prop-types';
import { Grid, Column, Row, Button, HeaderCompound, cls, Heading } from '../../packages/components';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import './styles/AAFModalPinInfo.scss';

const AAFModalPinInfo = (props = {}) => {
    const { handleClose, callback, config } = props;
    const logoUrl = Asset.get('logo_clarotv', '');
    const logoMetadata = Asset.get('landing_head_logoClarovideo', logoUrl);

    return (
        <ModalWrapper>
            <Grid className="aaf-modal-pin-content">
                <HeaderCompound
                    image="http://clarovideocdn7.clarovideo.net/pregeneracion/cms/apa/uat_a9028c58f218a7afd2d32ad11d0058e0/logo_clarotv.png?1586870669"
                    align="right"
                    onClick={(e) => handleClose(e, callback)}
                    textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                    icon={`${Asset.get('top_head_option_back')}`}
                />
                <Row className="aaf-modal-profile-pin">
                    <Column lg={12} className="aaf-modal-pin-title">
                        <Heading size={1}>
                            {Translator.get('setupPin_confirmation_title_label', 'Elige un PIN de 6 números')}
                        </Heading>
                    </Column>
                    <Column lg={12} className="aaf-modal-pin-description">
                        <p>
                            {Translator.get(
                                'setupPin_confirmation_detail_label',
                                'Con tu PIN podrás configurar la protección de pago para tus alquileres, suscripciones y las restricciones de contenido por edad para cada perfil. También podrás bloquear y desbloquear los canales de televisión para todos sus perfiles.'
                            )}
                        </p>
                    </Column>
                    <Column lg={12} className="aaf-modal-pin-profile">
                        <Button
                            activate
                            type="button"
                            className={cls('focusable', 'aaf-modal-pin-config')}
                            onClick={(e) => {
                                handleClose(e, callback);
                                config();
                            }}
                        >
                            {Translator.get('setupPin_confirmation_option_button_continue', 'Configurar')}
                        </Button>
                    </Column>
                    <Column lg={12}>
                        <Button
                            activate
                            type="button"
                            className={cls('focusable', 'aaf-modal-pin-cancel')}
                            onClick={(e) => {
                                handleClose(e, callback);
                            }}
                        >
                            {Translator.get('setupPin_confirmation_option_button_cancel', 'Cancelar')}
                        </Button>
                    </Column>
                </Row>
            </Grid>
        </ModalWrapper>
    );
};

AAFModalPinInfo.propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
};

export default withOnClose(AAFModalPinInfo);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalPinInfo.jsx